import debounce from 'lodash/debounce';
import vSelect from 'vue-select';

import './google-autocomplete.scss';
import template from './google-autocomplete.vhtml';
import { i18n } from '../../translation.js';
import { autocomplete } from './autocomplete';

export default {
	template,
	components: {
		vSelect,
	},
	props: {
		placeholder: {
			type: String,
			default: '',
		},
		searchText: {
			type: String,
			default: 'Søg...',
		}
	},
	data: () =>({
		geocoder: null,
		service: null,
		results: [],
		selected: null,
	}),
	watch: {
		selected() {
			this.resetResults();
			this.getDetails( this.selected );
		},
	},
	methods: {
		search(search, loading) {
			loading(true)
			this.getRepositories(search, loading, this)
		},
		getRepositories: debounce((search, loading, vm) => {
			autocomplete(search)
				.then( results => {
					vm.results = results;
				})
				.catch(e => console.error(e));

			loading(false);
		}, 500),
		getDetails( data ) {
			if (data !== null && data.hasOwnProperty('place_id')) {
				const request = {
					placeId: data.place_id,
				};
				const service = new google.maps.places.PlacesService(document.createElement('div'));
				service.getDetails(request, (details, status) => {
					if (status == google.maps.places.PlacesServiceStatus.OK) {
						const place = {};
						data.latitude = details.geometry.location.lat();
						data.longitude = details.geometry.location.lng();
						this.$emit('placechanged', data);
					}
				});
			}
		},
		resetResults() {
			this.results = [];
		},
	},
	mounted() {
		this.geocoder = new google.maps.Geocoder();
		this.service = new google.maps.places.AutocompleteService(null, { types: ['geocode'] });
	},
};

/* const service = new google.maps.places.PlacesService(document.createElement('div'));
service.getDetails({ reference: predictions[i].reference }, function (details, status) {
	if (details !== null) {
		place.latitude = details.geometry.location.lat();
		place.longitude = details.geometry.location.lng();
	}
}) */



// WEBPACK FOOTER //
// ./assets/_js/components/google-autocomplete/google-autocomplete.js